import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useGetFiltersInfo from '../hooks/useGetFiltersInfo';
import OptionsSelector from '../ui/OptionsSelector';

const FifthWheelFilter = ({ type }) => {
  const {
    data, prevData, params, updateParams,
  } = useGetFiltersInfo();
  const { t } = useTranslation('search');

  const options = data?.fifthWheels || prevData?.fifthWheels || [];

  const onChange = (value) => {
    updateParams({
      fifthWheels: value,
      page: 1,
    });
  };

  return (
    <OptionsSelector
      id="fifth-wheel-filter"
      onChange={onChange}
      options={options}
      placeholder={t('Search')}
      type={type}
      value={params.fifthWheels}
    />
  );
};

FifthWheelFilter.propTypes = {
  type: PropTypes.string.isRequired,
};

export default FifthWheelFilter;
